import { useEffect } from 'react';
import { useMinistryTeamStore } from '../../../../store/ministryTeamStore';
import { getMinistryTeams } from './apis/ministryTeam-apis';
import { MinistryTeamInputForm } from './_components/MinistryTeamInputForm';
import { MinistryTeamList } from './_components/MinistryTeamList';
import { Footer } from './_components/Footer';
import styles from './MinistryTeam1000.module.css';

export const MinistryTeam1000 = () => {
  const { setMinistryTeams, ministryTeams } = useMinistryTeamStore();

  useEffect(() => {
    getMinistryTeams().then(setMinistryTeams);
  }, [setMinistryTeams]);

  return (
    <div className={`col-xs-12 col-sm-12 col-md-12 ${styles.container}`}>
      <MinistryTeamInputForm />
      <MinistryTeamList />
      <Footer label="사역팀" count={ministryTeams.length} unit="개" />
    </div>
  );
};
